import { render, staticRenderFns } from "./base-autocomplete.vue?vue&type=template&id=1461112a"
import script from "./base-autocomplete.ts?vue&type=script&lang=ts&external"
export * from "./base-autocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports